
export class DocumentCollaborationSupplement {
  actionRequestedUserCode: string;
  actionRequestedUserName: string;
}
